import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { ActivityTypeLookupComponent } from './activity-type-lookup.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [ActivityTypeLookupComponent],
  exports: [ActivityTypeLookupComponent],
  providers: []
})
export class ActivityTypeLookupModule { }
